import { render, staticRenderFns } from "./ProfitPerWk.vue?vue&type=template&id=0b09b8c2&scoped=true&"
import script from "./ProfitPerWk.vue?vue&type=script&lang=js&"
export * from "./ProfitPerWk.vue?vue&type=script&lang=js&"
import style0 from "./ProfitPerWk.vue?vue&type=style&index=0&id=0b09b8c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b09b8c2",
  null
  
)

export default component.exports